import { CrewMember } from './scheduleApi'

export type CrewMemberUser = {
  email: string
  color?: string
}

const normalizeEmail = (email: string): string => email.trim().toLowerCase()

export const emailsMatch = (first: string | null | undefined, second: string | null | undefined): boolean => {
  if (!first?.trim() || !second?.trim()) {
    return false
  }
  return normalizeEmail(first) === normalizeEmail(second)
}

export const findCrewMemberByEmail = <T extends Pick<CrewMember, 'userEmail'>>(crew: T[] | null | undefined, email: string | null | undefined): T | undefined => {
  return crew?.find(member => emailsMatch(member.userEmail, email))
}

export const buildUsersByEmail = <T extends CrewMemberUser>(users: T[]): Map<string, T> => {
  return new Map(users.filter(user => !!user.email).map(user => [normalizeEmail(user.email), user]))
}

export const findUserForCrewMember = <T extends CrewMemberUser>(
  member: CrewMember,
  usersByEmail: Map<string, T>
): T | undefined => {
  if (!member.userEmail) {
    return undefined
  }

  return usersByEmail.get(normalizeEmail(member.userEmail))
}

export const enrichCrewMembers = (crew: CrewMember[], users: CrewMemberUser[]): CrewMember[] => {
  const usersByEmail = buildUsersByEmail(users)

  return crew.map(member => ({
    ...member,
    hasStockAvatar: !member.hasCustomAvatar,
    color: findUserForCrewMember(member, usersByEmail)?.color,
  }))
}
